export default __webpack_public_path__ + "static/media/wedding-picture.b6d5dd4c.png";